import config from "../../config/config.json";
import { headers } from "../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../../APIHelpers/Responses";

export const eiwrsDepotManagementServices = {
  //Depot Column
  addNewStudyDepotColumn,
  updateStudyDepotColumnData,
  deleteStudyDepotColumnData,
  softDeleteRestoreStudyDepotColumn,
  getStudyDepotColumnData,
  
  //Depot Row
  addNewStudyDepotRow,
  updateStudyDepotRowData,
  deleteStudyDepotRowData,
  softDeleteRestoreStudyDepotRow,
  updateStudyDepotRowOrderData,
  getStudyDepotRowData,
  downloadDepotKitReport,
  getHeighestVersionDepotRowHistory,
  getStudyDepotAuditTrials,
  getStudyAvailableKitInDepot
};

// Get Study Depot Column
async function getStudyDepotColumnData(status, studyId, searchData, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyDepotColumnData/${status}/${studyId}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyDepotColumnData/${status}/${studyId}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Add New Study Depot Column
async function addNewStudyDepotColumn(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewStudyDepotColumn`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Update Study Depot Column
async function updateStudyDepotColumnData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateStudyDepotColumnData`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Soft Delete & Restore Study Depot Column
async function softDeleteRestoreStudyDepotColumn(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreStudyDepotColumn`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Delete Study Depot Column
async function deleteStudyDepotColumnData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteStudyDepotColumnData`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Get Study Depot Row
async function getStudyDepotRowData(status, studyId, StudyMode, searchData, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyDepotRow/${status}/${studyId}/${StudyMode}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyDepotRow/${status}/${studyId}/${StudyMode}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Add New Study Depot Row
async function addNewStudyDepotRow(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewStudyDepotRow`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Update Study Depot Row
async function updateStudyDepotRowData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateStudyDepotRowData`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Soft Delete & Restore Study Depot Row
async function softDeleteRestoreStudyDepotRow(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreStudyDepotRow`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Update Study Depot Order
async function updateStudyDepotRowOrderData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateStudyDepotRowOrderData`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Delete Study Depot Row
async function deleteStudyDepotRowData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteStudyDepotRowData`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Get Study Depot Row Heighest version
async function getHeighestVersionDepotRowHistory(studyId, depotId) {
  let response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getHeighestVersionDepotRowHistory/${studyId}/${depotId}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  const data = await response.json();
  return data;
}

// Get Study Depot Row Audit Trial
async function getStudyDepotAuditTrials(studyId, depotId) {
  let response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyDepotAuditTrials/${studyId}/${depotId}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  const data = await response.json();
  return data;
}

// Get Study Vailable Kit in Depot
async function getStudyAvailableKitInDepot(studyId, depotId, mode) {
  let response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyAvailableKitInDepot/${studyId}/${depotId}/${mode}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  const data = await response.json();
  return data;
}

// Get Depot Kit Report
async function downloadDepotKitReport(studyId, depotId, mode) {
  let response = await fetch(
      `${config.API_URL_USER_ONBOARDING}downloadDepotKitReport/${studyId}/${depotId}/${mode}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  const data = await response.json();
  return data;
}